<template>
  <div
    class="sm:relative flex items-center p-3 sm:p-6 bg-white !rounded-b-lg sm:rounded-bl-none sm:rounded-br-lg shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]"
    :class="[currentStep > 1 ? 'justify-between' : 'justify-end']"
  >
    <portal-button
      color="gray-no-border"
      @click.prevent="$emit('previous-step')"
      v-if="currentStep > 1"
    >
      <ion-icon
        name="chevron-back-outline"
        class="text-xl"
      ></ion-icon>
      <span class="font-bold">Back</span>
    </portal-button>
    <portal-button
      v-tooltip="shouldShowTooltip ? 'Scroll to bottom to enable continue button' : ''"
      color="primary"
      @click.prevent="$emit('next-step')"
      v-if="currentStep < maxSteps && !onPaymentStep"
      class="flex items-center justify-center sm:!w-40 w-full"
      :class="{ '!w-[60%]': currentStep > 1 && currentStep !== maxSteps }"
      :disabled="shouldShowTooltip || noPackageSelected"
    >
      <span class="font-bold">Continue</span>
      <ion-icon
        name="chevron-forward-outline"
        class="text-xl"
      ></ion-icon>
    </portal-button>

    <!-- Payment Method Step Buttons -->
    <div
      v-if="currentStep < maxSteps && onPaymentStep"
      class="flex items-center gap-2"
    >
      <portal-button
        v-if="isPaymentOptional"
        color="primary-bordered"
        @click.prevent="$emit('skip-payment-step')"
        class="flex items-center justify-center sm:!w-28"
        :disabled="paymentSubmitLoading"
      >
        <span class="font-bold">Skip</span>
      </portal-button>
      <portal-button
        color="primary"
        @click.prevent="$emit('payment-step-continue-click')"
        class="flex items-center justify-center sm:!w-40 w-full"
        :class="{ '!w-[60%]': currentStep > 1 && currentStep !== maxSteps }"
        :disabled="disableContinueButton || paymentSubmitLoading"
      >
        <span class="font-bold">Continue</span>
        <ion-icon
          name="chevron-forward-outline"
          class="text-xl"
          v-show="!paymentSubmitLoading"
        ></ion-icon>
        <client-loading-indicator
          class="text-primary-500 fill-gray-100 ml-2 w-5 h-5"
          v-show="paymentSubmitLoading"
        />
      </portal-button>
    </div>

    <!-- Payment Method Step Continue Btn -->
    <portal-button
      color="primary"
      class="flex items-center justify-center gap-1 w-[70%] sm:w-40"
      @click.prevent="$emit('accept-proposal')"
      v-if="currentStep === maxSteps"
      :disabled="disableAcceptTermsButton"
    >
      <ion-icon
        name="checkmark-circle-outline"
        class="text-xl"
      ></ion-icon>
      <span class="font-bold">Accept</span>
    </portal-button>
  </div>
</template>

<script>
import PortalButton from "../../../ClientPortal/UI/PortalButtons/PortalButton.vue"
import ClientLoadingIndicator from "../../../ClientPortal/client_auth/components/client-loading-indicator.vue"

export default {
  name: "PortalBillingProposalFooter",
  components: { ClientLoadingIndicator, PortalButton },
  emits: ["previous-step", "next-step", "payment-step-continue-click", "skip-payment-step", "accept-proposal"],
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    maxSteps: {
      type: Number,
      required: true,
    },
    disableAcceptTermsButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableContinueButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    onPaymentStep: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPaymentOptional: {
      type: Boolean,
      required: false,
      default: false,
    },
    paymentSubmitLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasOverflow: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasScrolledToBottom: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentStepName: {
      type: String,
      required: false,
      default: null,
    },
    selectedPackage: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    shouldShowTooltip() {
      return this.currentStepName === "Review Services" && this.hasOverflow && !this.hasScrolledToBottom
    },
    noPackageSelected() {
      return this.currentStepName === "Packages" && this.selectedPackage === null
    },
  },
}
</script>
